import axios from "axios";
import { parseAPIResponse } from "./parse-api-response";

export const request = async (options) => {

    const onError = (error) => {
        return Promise.reject(error.response);
    }

    return axios(options)
        .then(parseAPIResponse)
        .catch(onError)

}